module.exports = __webpack_public_path__ + "img/ber.d11e462f.svg";